;
export var Colors;
(function (Colors) {
    Colors.colors = {
        "calendar": {
            "1": {
                "hex_code": "#ac725e",
                "displayName": "Cocoa",
                "name": "cocoa",
            },
            "2": {
                "hex_code": "#d06b64",
                "displayName": "Flamingo",
                "name": "flamingo",
            },
            "3": {
                "hex_code": "#f83a22",
                "displayName": "Tomato",
                "name": "tomato",
            },
            "4": {
                "hex_code": "#fa573c",
                "displayName": "Tangerine",
                "name": "tangerine",
            },
            "5": {
                "hex_code": "#ff7537",
                "displayName": "Pumpkin",
                "name": "pumpkin",
            },
            "6": {
                "hex_code": "#ffad46",
                "displayName": "Mango",
                "name": "mango",
            },
            "7": {
                "hex_code": "#42d692",
                "displayName": "Eucalyptus",
                "name": "eucalyptus",
            },
            "8": {
                "hex_code": "#16a765",
                "displayName": "Basil",
                "name": "basil",
            },
            "9": {
                "hex_code": "#7bd148",
                "displayName": "Pistachio",
                "name": "pistachio",
            },
            "10": {
                "hex_code": "#b3dc6c",
                "displayName": "Avocado",
                "name": "avocado",
            },
            "11": {
                "hex_code": "#fbe983",
                "displayName": "Citron",
                "name": "citron",
            },
            "12": {
                "hex_code": "#fad165",
                "displayName": "Banana",
                "name": "banana",
            },
            "13": {
                "hex_code": "#92e1c0",
                "displayName": "Sage",
                "name": "sage",
            },
            "14": {
                "hex_code": "#9fe1e7",
                "displayName": "Peacock",
                "name": "peacock",
            },
            "15": {
                "hex_code": "#9fc6e7",
                "displayName": "Cobalt",
                "name": "cobalt",
            },
            "16": {
                "hex_code": "#4986e7",
                "displayName": "Blueberry",
                "name": "blueberry",
            },
            "17": {
                "hex_code": "#9a9cff",
                "displayName": "Lavender",
                "name": "lavender",
            },
            "18": {
                "hex_code": "#b99aff",
                "displayName": "Wisteria",
                "name": "wisteria",
            },
            "19": {
                "hex_code": "#c2c2c2",
                "displayName": "Graphite",
                "name": "graphite",
            },
            "20": {
                "hex_code": "#cabdbf",
                "displayName": "Birch",
                "name": "birch",
            },
            "21": {
                "hex_code": "#cca6ac",
                "displayName": "Beetroot",
                "name": "beetroot",
            },
            "22": {
                "hex_code": "#f691b2",
                "displayName": "Cherry Blossom",
                "name": "cherry Blossom",
            },
            "23": {
                "hex_code": "#cd74e6",
                "displayName": "Grape",
                "name": "grape",
            },
            "24": {
                "hex_code": "#a47ae2",
                "displayName": "Amethyst",
                "name": "amethyst",
            },
        },
        "event": {
            "1": {
                "hex_code": "#a4bdfc",
                "displayName": "Lavender",
                "name": "lavender",
            },
            "2": {
                "hex_code": "#7ae7bf",
                "displayName": "Sage",
                "name": "sage",
            },
            "3": {
                "hex_code": "#dbadff",
                "displayName": "Grape",
                "name": "grape",
            },
            "4": {
                "hex_code": "#ff887c",
                "displayName": "Flamingo",
                "name": "Flamingo",
            },
            "5": {
                "hex_code": "#fbd75b",
                "displayName": "Banana",
                "name": "banana",
            },
            "6": {
                "hex_code": "#ffb878",
                "displayName": "Tangerine",
                "name": "tangerine",
            },
            "7": {
                "hex_code": "#46d6db",
                "displayName": "Peacock",
                "name": "peacock",
            },
            "8": {
                "hex_code": "#e1e1e1",
                "displayName": "Graphite",
                "name": "graphite",
            },
            "9": {
                "hex_code": "#5484ed",
                "displayName": "Blueberry",
                "name": "blueberry",
            },
            "10": {
                "hex_code": "#51b749",
                "displayName": "Basil",
                "name": "basil",
            },
            "11": {
                "hex_code": "#dc2127",
                "displayName": "Tomato",
                "name": "tomato",
            },
        }
    };
    Colors.eventDisplayNames = {
        1: "Lavender",
        2: "Sage",
        3: "Grape",
        4: "Flamingo",
        5: "Banana",
        6: "Tangerine",
        7: "Peacock",
        8: "Graphite",
        9: "Blueberry",
        10: "Basil",
        11: "Tomato",
    };
    Colors.calendarDisplayNames = {
        1: "Cocoa",
        2: "Flamingo",
        3: "Tomato",
        4: "Tangerine",
        5: "Pumpkin",
        6: "Mango",
        7: "Eucalyptus",
        8: "Basil",
        9: "Pistachio",
        10: "Avocado",
        11: "Citron",
        12: "Banana",
        13: "Sage",
        14: "Peacock",
        15: "Cobalt",
        16: "Blueberry",
        17: "Lavender",
        18: "Wisteria",
        19: "Graphite",
        20: "Birch",
        21: "beetroot",
        22: "Cherry Blossom",
        23: "Grape",
        24: "Amethyst",
    };
})(Colors || (Colors = {}));
//# sourceMappingURL=calendar-colors.js.map